import { render, staticRenderFns } from "./ImageBoxComponent.vue?vue&type=template&id=31b100d7&scoped=true&"
import script from "./ImageBoxComponent.vue?vue&type=script&lang=js&"
export * from "./ImageBoxComponent.vue?vue&type=script&lang=js&"
import style0 from "./ImageBoxComponent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ImageBoxComponent.vue?vue&type=style&index=1&id=31b100d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b100d7",
  null
  
)

export default component.exports